import React, { ReactElement } from "react";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import BestParaquatLawyersWrapper from "@components/layouts/bestparaquatlawyersWrapper";
import MainBanner from "@components/bestparaquatlawyers/mainBanner";

const OffersList = dynamic(() => import("@components/shared/offersList"));
const Lawsuits = dynamic(
    () => import("@components/bestparaquatlawyers/lawsuits"),
);
const Parkinson = dynamic(
    () => import("@components/bestparaquatlawyers/parkinson"),
);
const SideEffects = dynamic(
    () => import("@components/bestparaquatlawyers/sideEffects"),
);

export default function BestParaquatLawyersHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <BestParaquatLawyersWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <Lawsuits />
            <Parkinson />
            <SideEffects />
        </BestParaquatLawyersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
